var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bill-pay-login__main gds-flex-container" }, [
    _c("div", { staticClass: "bill-pay-login__login-type-container" }, [
      _c(
        "section",
        {
          staticClass: "bill-pay-login__account-select",
          attrs: { id: "top-target" }
        },
        [
          _c("h2", { staticClass: "gds-display-1" }, [
            _vm._v("Choose Account")
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "bill-pay-login__form",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c(
                "fieldset",
                { staticClass: "gds-fieldset" },
                [
                  _c(
                    "legend",
                    { staticClass: "gds-body-normal gds-space-stack-ml" },
                    [
                      _vm._v(
                        "To stop service, please select the account from the list below."
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.accounts, function(account) {
                    return _c(
                      "label",
                      {
                        key: account.accountNumber,
                        staticClass:
                          "bill-pay-login__form--radio-label-flex gds-radio"
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.selectedAccountNumber,
                              expression: "selectedAccountNumber"
                            }
                          ],
                          attrs: { type: "radio" },
                          domProps: {
                            value: account.accountNumber,
                            checked: _vm._q(
                              _vm.selectedAccountNumber,
                              account.accountNumber
                            )
                          },
                          on: {
                            change: function($event) {
                              _vm.selectedAccountNumber = account.accountNumber
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("span", { staticClass: "gds-radio__faux" }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "gds-radio__label bill-pay-login__radio-label"
                          },
                          [
                            account.nickname
                              ? _c("span", [
                                  _c("b", [_vm._v(_vm._s(account.nickname))]),
                                  _vm._v(" "),
                                  _c("br")
                                ])
                              : _vm._e(),
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("addressFormat")(account.address, {
                                    separator: ", "
                                  })
                                ) +
                                "\n              "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n              Acct #: " +
                                _vm._s(account.accountNumber) +
                                "\n            "
                            )
                          ]
                        )
                      ]
                    )
                  })
                ],
                2
              )
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "gds-space-stack-l" }, [
            _c(
              "button",
              {
                staticClass: "gds-button gds-secondary gds-space-inline-m",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    return _vm.ReturnToSender("/stop-service")
                  }
                }
              },
              [_vm._v("Cancel")]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "gds-button gds-space-inline-m",
                on: {
                  click: function($event) {
                    return _vm.nextPage()
                  }
                }
              },
              [_vm._v("Next")]
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }